import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// material ui
import Dialog from '@material-ui/core/Dialog';

const CustomDialog = props => {
  const {
    children,
    fullWidth,
    hasFixedWidth,
    modal,
    open,
    onRequestClose,
    className,
    classes
  } = props;

  return (
    <Dialog
      classes={{
        container: 'custom-dialog-body',
        paper: classNames('custom-dialog-content', {
          'full-width': fullWidth,
          'has-fixed-width': hasFixedWidth,
          [className]: className,
        }),
        ...classes
      }}
      disableBackdropClick={modal}
      disableEscapeKeyDown={modal}
      open={open}
      onClose={onRequestClose}
    >
      {children}
    </Dialog>
  );
};

CustomDialog.defaultProps = {
  autoScrollBodyContent: true,
  fullWidth: false,
  hasFixedWidth: true,
  modal: false,
};

CustomDialog.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  classes: PropTypes.object,
  fullWidth: PropTypes.bool,
  hasFixedWidth: PropTypes.bool,
  modal: PropTypes.bool,
  open: PropTypes.bool,
  onRequestClose: PropTypes.func,
  className: PropTypes.string,
};

export default CustomDialog;
